module.exports = __webpack_public_path__ + "img/defaultPersonImage.f1dc26bb.png";